import classnames from 'classnames/bind'
import React, { InputHTMLAttributes } from 'react'

import css from './styles.module.scss'

const cx = classnames.bind(css)
export interface InputProps extends InputHTMLAttributes<any> {
  className?: string
  textarea?: boolean
  rows?: number
  addRequiredIndicatorOnLabel?: boolean
  forwardRef?: any
}

function MockInput({
  className,
  type,
  textarea,
  rows,
  name,
  required,
  placeholder,
  addRequiredIndicatorOnLabel,
  min,
  max,
  minLength,
  maxLength,
  defaultValue,
  defaultChecked,
  onError,
  forwardRef,
  ...inputProps
}: InputProps) {
  const placeHolder = placeholder
    ? placeholder + (addRequiredIndicatorOnLabel && required ? ' *' : '')
    : null

  const textareaComponent = (
    <textarea
      ref={forwardRef}
      className={cx(css.textarea, className)}
      rows={rows}
      name={name}
      placeholder={placeHolder}
      {...inputProps}
    />
  )

  const inputComponent = (
    <input
      {...inputProps}
      type={type}
      name={name}
      ref={forwardRef}
      maxLength={maxLength}
      defaultChecked={defaultChecked}
      defaultValue={defaultValue}
      placeholder={placeHolder}
      className={cx(css.input, className)}
    />
  )

  return textarea ? textareaComponent : inputComponent
}

MockInput.defaultProps = {
  addRequiredIndicatorOnLabel: true,
}

export default MockInput
